import { takeEvery, put } from 'redux-saga/effects';
import * as types from './constants';

import {Layout} from '@components/layout';
import {TOASTER_DISPATCH} from '@components/layout/constants';

function* rootSagas() {
    yield takeEvery([
         types.GET_USER_TASKS_SORTED_LIST_SUCCESS,
         types.GET_USER_TASKS_SORTED_LIST_FAILURE
    ], (Layout.actions.closePreloaderSaga));
    yield takeEvery([
        types.GET_USER_TASKS_SORTED_LIST_REQUEST
    ], (Layout.actions.openPreloaderSaga));


    yield takeEvery([
        'ws:UserTasks/UserTaskCreateTaskNotification',
    ], function* (payload) {
        let {data: {task: {title, comment}}} = payload;
        yield put({
            type: TOASTER_DISPATCH,
            toast: {
                type: 'info',
                message: `Задача "${title}" создана. ${comment}`,
            }
        })
    });
    yield takeEvery([
        'ws:UserTasks/UserTaskBefore15MinNotification',
    ], function* (payload) {
        let {data: {task: {title, comment}}} = payload;
        yield put({
            type: TOASTER_DISPATCH,
            toast: {
                type: 'info',
                message: `Скоро: ${title}. ${comment}`,
            }
        })
    });
    yield takeEvery([
        'ws:UserTasks/UserTaskNotification',
    ], function* (payload) {
        let {data: {task: {title, comment}}} = payload;
        yield put({
            type: TOASTER_DISPATCH,
            toast: {
                type: 'info',
                message: `Сейчас: ${title}. ${comment}`,
            }
        })
    });
    yield takeEvery([
        'ws:UserTasks/UserTaskReportNotification',
    ], function* (payload) {
        let {data: {task: {title, report}}} = payload;
        yield put({
            type: TOASTER_DISPATCH,
            toast: {
                type: 'info',
                message: `Задача "${title}" завершена. Отчет: ${report}`,
            }
        })
    });
}

export default rootSagas;
